import OButton from "components/reusable/OButton";
import useToastContext from "hooks/useToastContext";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { apiGet, apiPost, apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { useTranslation } from "react-i18next";
import OInputField from "components/reusable/OInputField";
import FormValidation from "utils/formValidation";
import { IoAdd, IoClose } from "react-icons/io5";
import helpers from "utils/helpers";
import { FaEdit } from "react-icons/fa";
import { MdFileDownloadDone } from "react-icons/md";
const VehicleAdd = ({ getAllNotifications, handleCategory, categoryAdd, type, item }) => {
  const [loading, setLoading] = useState(false);
  const formValidation = FormValidation();
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
  });

  const notification = useToastContext();
  const [driver, setDriver] = useState(categoryAdd?.driverDetails?._id||'')
  // add notification function start
  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const res = categoryAdd?.type == 'edit' ? await apiPut(apiPath.editVehicle + '/' + categoryAdd?._id, data) : await apiPost(apiPath.addVehicle, data);
      if (res.data.success) {
        notification.success(res?.data?.message);
        handleCategory();
        getAllNotifications();
      } else {
        notification.error(res?.data?.message);
      }
    } catch (err) {
      console.error("err:", err);
    } finally {
      setLoading(false);
    }

  };

  const [driverList, setDriverList] = useState([])
  const getDriverList = async () => {
    try {
      const res = await apiGet(apiPath.getVehicleDriverList);
      if (res?.data?.success) {
        setDriverList(res?.data?.results)
        setDriver(categoryAdd?.driverDetails?._id)
      } else {
        setDriverList([])
      }
    } catch (err) {
      console.error("err:", err);
    }
  }

  useEffect(() => {
    if (categoryAdd.type == 'edit') {
      const{dotNumber,vehicleNumber,caNumber}=categoryAdd
      reset({dotNumber,vehicleNumber,caNumber})
    } else {
      reset()
    }
    if (categoryAdd.type == 'assign'||categoryAdd.type == 'update') {
      getDriverList()
    }
  }, [categoryAdd])


  const handleSubmitDriver = async () => {
    if(!driver){
      notification.error('Please select driver.');
      return
    }
    try {
      setLoading(true);
      const payload={assignedDriver:driver}
      const res = await apiPut(apiPath.editVehicle + '/' + categoryAdd?._id, payload)
      if (res.data.success) {
        notification.success(res?.data?.message);
        handleCategory();
        getAllNotifications();
      } else {
        notification.error(res?.data?.message);
      }
    } catch (err) {
      console.error("err:", err);
    } finally {
      setLoading(false);
    }
  }


  return (
    <div>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative my-6 mx-auto">
          <div className="sm:py-4 sm:px-2 py-8 px-7 ">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full  sm:w-[400px] bg-white outline-none focus:outline-none">
              <div className="dark:bg-gray-900 flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold dark:text-white">
                  {helpers.ternaryCondition((categoryAdd.type == 'assign'||categoryAdd.type == 'update'), helpers.ternaryCondition(categoryAdd.type == 'update', t("UPDATE_DRIVER"), t("ASSIGN_DRIVER")), t("ADD_VEHICLE"))}
                </h3>
                <button
                  className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                  onClick={() => handleCategory()}
                >
                  <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                    ×
                  </span>
                </button>
              </div>
              {helpers.ternaryCondition((categoryAdd?.type == 'assign'||categoryAdd?.type == 'update'),
                <div className="relative p-6 flex-auto dark:bg-gray-800">
                  <div className="grid grid-cols-1 sm:grid-cols-1">
                    <div className="px-2">
                      <label htmlFor="driver" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Driver<span class="text-red-500">*</span></label>
                      <select
                        id=""
                        type="text"
                        name="Select Driver"
                        className="block p-2 w-full text-sm text-[#A5A5A5] dark:bg-white dark:text-black  bg-transparent border-2 dark:border-[#fff] rounded-lg border-[#DFDFDF] dark:border-gray-600"
                        placeholder=" "
                        onChange={(e) => setDriver(e?.target?.value)}
                        value={driver}
                      >
                        <option defaultValue value="">
                          {t("Select Driver")}
                        </option>
                        {driverList?.map((resp) => { return (<option key={resp?._id} value={resp?._id}>{helpers.capitalizeFirstWord(resp?.fullName)}</option>) })}
                      </select>
                    </div>
                  </div>
                </div>,
                <div className="relative p-6 flex-auto dark:bg-white">
                  <div className="grid grid-cols-1 sm:grid-cols-1">
                    <div className="px-2">
                      <OInputField
                        wrapperClassName=""
                        name="vehicleNumber"
                        autoFocus
                        placeholder={t('Enter Vehicle Number')}
                        maxLength={10}
                        inputLabel={
                          <>
                            {t("VEHICLE_NUMBER")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        register={register("vehicleNumber", formValidation.vehicleNumber)}
                        errors={errors}
                      />
                    </div>

                    <div className="px-2">
                      <OInputField
                        wrapperClassName=""
                        name="dotNumber"
                        placeholder={t('Enter DOT Number')}
                        maxLength={65}
                        inputLabel={
                          <>
                            {t("DOT_NUMBER")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        register={register("dotNumber", formValidation.truckDOTNumber)}
                        errors={errors}
                      />
                    </div>
                    <div className="px-2">
                      <OInputField
                        wrapperClassName=""
                        name="caNumber"
                        placeholder={t('Enter CA Number')}
                        maxLength={65}
                        inputLabel={
                          <>
                            {t("CA_NUMBER")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        register={register("caNumber", formValidation.caNumberSP)}
                        errors={errors}
                      />
                    </div>
                  </div>

                </div>)}

              <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b dark:bg-gray-900">
                <button
                  className="text-black bg-[#E1E1E1] font-normal px-6 flex gap-2 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                  type="button"
                  onClick={() => handleCategory()}
                  title={t("O_CLOSE")}
                >
                  <IoClose size={19} />{t("O_CLOSE")}
                </button>
                {helpers.ternaryCondition((categoryAdd?.type == 'assign' || categoryAdd?.type == 'update'), <OButton
                  extraClasses={'!px-6'}
                  label={<><MdFileDownloadDone size={16} className="mr-2" /> Submit</>}
                  type="button"
                  title={t("O_SUBMIT")}
                  onClick={handleSubmitDriver}
                  loading={loading}
                  disabled={loading}
                />,
                  <OButton
                    extraClasses={'!px-6'}
                    label={<>{helpers.ternaryCondition(categoryAdd?.type == 'edit', <FaEdit size={16} className="mr-2" />, <IoAdd size={16} className="mr-2" />)}{helpers.ternaryCondition(categoryAdd?.type == 'edit', t("O_EDIT"), t("O_ADD"))}</>}
                    type="submit"
                    title={helpers.ternaryCondition(categoryAdd?.type == 'edit', t("O_EDIT"), t("O_ADD"))}
                    onClick={handleSubmit(onSubmit)}
                    loading={loading}
                    disabled={loading}
                  />)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </div>
  );
};

export default VehicleAdd;
